var map = {
	"./australia_a_league.png": "MZG/",
	"./la_liga.png": "yj2b",
	"./premier_league.png": "AWBF",
	"./serie_a.png": "Ariy",
	"./wolves.png": "/9Rc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "H2rg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg ^\.\/.*\.png$
// module id = H2rg
// module chunks = 1